module.exports = __webpack_public_path__ + "static/media/RP-B_S_Timeless_Sforza_DKGrey.95512561.png";